import DispatchablePayload from './DispatchablePayload';

let _lastId = 0;

class TrackerEvent extends DispatchablePayload {
	constructor(source) {
		super(source);

		/**
		 * Identifier provided in response to TrackerMessageInitialize.
		 */
		this.instance_id = undefined;

		/**
		 * One of TrackerEvent.TYPES. For custom events, set type to "custom" and then provide "custom_event_type".
		 */
		this.event_type = undefined;

		/**
		 * Location inside the tour. Sphere name, page URL...
		 */
		this.location = undefined;

		/**
		 * How many locations (spheres) did the user travel to reach this point. Starts at 1 for the initial location
		 * and should be increased on each location change (even when returning to previously visited locations)
		 */
		this.journey_step = undefined;

		/**
		 * Target name, if relevant to the event.
		 */
		this.target = undefined;

		/**
		 * Numeric value associated with event. Can be amount or true/false switch.
		 */
		this.value = undefined;

		/**
		 * Was this event triggered by user or by the application (as closely as the client can determine)
		 */
		this.is_user_triggered = undefined;

		/**
		 * Window's state at the moment of event creation
		 */
		this.is_window_focused = undefined;

		/**
		 * True if presentation is currently in VR mode
		 */
		this.in_vr_mode = undefined;

		/**
		 * If event_type is custom, set this to arbitrary string
		 */
		this.custom_event_type = undefined;

		/**
		 * Any additional data packed into JSON
		 */
		this.additional_data = undefined;

		/**
		 * How many milliseconds ago has the event happened. Useful if events are backlogged. If sent immediately, this can be 0.
		 */
		this.timestamp_ago_ms = undefined;

		// Client only
		_lastId++;
		this.id = 'E' + _lastId;
		this.timestamp = new Date();

		if (source) {
			Object.assign(this, source);
		}
	}

	prepareForDispatch(now) {
		this.timestamp_ago_ms = now - this.timestamp;
	}

	toString() {
		return `${this.id} ${this.event_type} (${this.journey_step}. ${this.location})`;
	}
}

TrackerEvent.TYPES = {
	enter: 'enter',
	exit: 'exit',
	end_session: 'end_session',
	location_enter: 'location_enter',
	location_exit: 'location_exit',
	hotspot_click: 'hotspot_click',
	vr_mode_enter: 'vr_mode_enter',
	vr_mode_exit: 'vr_mode_exit',
	custom: 'custom'
};

export default TrackerEvent;
